import { useEffect, useState } from "react";
import { getProducerAttachments } from "../../../../../shared/services/get-attachments.service";
import { AttachmentFile } from "../../../../../shared/models/attachment-file.model";
import styles from './ProducerImage.module.scss';
import { Link } from 'react-router-dom';

interface ProducerImageProps {
    producerId: string;
}

export default function SmallProducerImage({ producerId }: ProducerImageProps) {

    const [imageId, setImageId] = useState<string>();
    const [imageFailed, setImageFailed] = useState(false);

    useEffect(() => {
        getProducerAttachments(producerId).then((response) => {
            const image = response?.data?.find((attachment: AttachmentFile) => attachment.type === 'IMAGE');
            setImageId(image?.id);
        }).catch(() => {
            setImageId(undefined);
        });
    }, [producerId]);

    const hasImage = !!imageId && !imageFailed;

    return (
        <div className={styles.image_container}>
            {hasImage ? (
                <Link to={`/producer-details-view/${producerId}`}>
                    <img
                        className={styles.producer_image}
                        src={`${process.env.REACT_APP_BASE_URL}Images/file/${imageId}`}
                        alt="Producer"
                        onError={() => setImageFailed(true)}
                    />
                </Link>
            )
                :
                <Link to={`/producer-details-view/${producerId}`}>
                    <div className={styles.grey_circle}>
                    </div>
                </Link>
            }
        </div>
    );
}